import {changeLangTitle} from "../common/util";
// Default configuration of the modal, if modal is not overwrited for a specific class
$(() => {
    $('[data-fancybox]').fancybox({
        touch : false,
        autoFocus:false,

        beforeShow: function(){
            $("body").css({'overflow-y':'hidden'});
        },
        afterShow: function(){
            changeLangTitle()
        },
        afterClose: function(){
            $("body").css({'overflow-y':'visible'});
        },
    });
})

